import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useMenu } from "../../hooks/useMenu";
import { ActionIconItem } from "./ActionIconItem";

export const Navigation = ({ item, data }) => {
    const navigate = useNavigate();
    const [idConfiguration, setIdConfiguration] = useState(true);

    const [menuList] = useMenu();
    const {
        menu
    } = menuList;

    const handleRedirect = (path, id_user_action) => {
        const id = data?.id;
        const id_flow_process = data?.id_flow_process;

        let userConfig = null;
        let nameConfig = null;
        if (id_user_action) {
            menu.forEach((item) => {
                if (item.id_user_action === id_user_action) {
                    userConfig = item.configuration;
                    nameConfig = item.name;
                }
            });
            setIdConfiguration(true);
        }
        data.id_user_action = id_user_action || '';
        data.work_flow = item.work_flow || ''
        if (path.includes('flow-')) {
            navigate(`${path}${id}`, { state: { config: { id, data } } });
            return
        }
        if (id && id_flow_process == null && !path.includes('invoice') && !path.includes('companies')
            && !path.includes('configuration') && !path.includes('provider') && !idConfiguration) {
            navigate(`${path}${id}`, { state: { config: { id, data } } });
        }
        else {
            navigate(`${path}`, { state: { config: { data }, configuration: userConfig || '', title: nameConfig || '' } });
        }
    };

    return (
        <ActionIconItem
            item={item}
            onClick={(itemData) => {
                console.log('itemData ', itemData);
                handleRedirect(itemData.config.path, itemData.config?.id_user_action || '')
            }}
        />
    )
};